<template>
<div>
	<b-card>
		<div>
			<filter-swapper
				:controlHeightButtons="controlHeight"
			>
				<template #slot1>
					<form-render
						:key="keyFormRenderTD"
						:fields="fields"
						:buttonSend="buttonSend"
            class="mb-1"
						:form.sync="formFilter"
						@send="filterData"
						containerButtonsClass="col-sm-12 col-md-2 container-button mt-2"
					>
					<template #buttons>
						<b-button
							variant="outline-light"
							v-b-tooltip.hover
							title="Limpiar filtros"
							class="ml-2"
							@click="cleanFilter"
							:disabled="!formFilter"
							><feather-icon icon="RefreshCwIcon"
						/></b-button>
					</template>
					</form-render>
				</template>
			</filter-swapper>
		</div>
		<section>
      <b-tabs class="tab-primary">
        <b-tab 
          v-for="(service) in carrier.services"
          :key="service.id" @click="setServiceCode(service.code)"
        >
          <template #title>
            <div class="tab-title">
            <b-spinner small v-if="loading[service.code]"/>
            <span> {{ service.name }} </span>
            </div>
          </template>
        </b-tab>
      </b-tabs>
      <table-render
        id="table-configurations-couriers"
        :schema="schema"
        :rows="rows"
        :actions="actions"
        :loading="loading.courierTransitDay"
        :key="keyTransitDayTable"
        show-empty
        :emptyHtml="empty"
        stickyHeader="true"
        v-if="carrier.services"
      >
      </table-render>
    </section>
		
	</b-card>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import BaseServices from '@/store/services/index'

export default {
  name: 'TransitDays',
  props: ['formTab'],
  data() {
    return {
      schema: [],
      rows: [],
      actions: [],
      controlHeight: { class: 'row mb-2 spacing-label-field' },
      buttonSend: { title: 'Buscar', icon: 'SearchIcon', color: 'warning' },
      loading: {
        first: true,
        courierTransitDay: false
      },
      formFilter: {},
      fields: [],
      pagination: {
        limit: 10,
        page: 1,
        total: 0
      },
      keyFormRenderTD: 0,
      keyTransitDayTable: 0,
      baseService: new BaseServices(this),
      serviceCode: null,
      emptyFixedMsg: '<span class="text-center w-full">Utiliza los selectores disponibles en la parte superior <br/>para realizar una búsqueda eficiente y acceder a la información deseada.</span>',
      empty: '',
      statusTypeOptions: [
        {id: 1, text: 'Expirado'},
        {id: 2, text: 'Vigente'},
        {id: 3, text: 'Pendiente'}
      ]
    }
  },
  computed: {
    ...mapGetters({
      mySession: 'getSession',
      carrier: 'getCarrier',
      courierTransitDays: 'getCourierTransitDays'
    })
  },
  watch: {
    mySession() {
    },
    courierTransitDays() {
      if (!this.m_isNotEmpty(this.courierTransitDays)) {
        this.empty = ''
        this.rows = []
      } else {
        this.rows = this.courierTransitDays.map(data => ({
          ...data,
          vigency_range: `${this.$options.filters.dbDateUTCToGMTlocal(data.start_date, 'DD/MM/YYYY')} - ${this.$options.filters.dbDateUTCToGMTlocal(data.ending_date, 'DD/MM/YYYY')}`
        }))
      }
      this.loading.courierTransitDay = false
      this.loading[this.serviceCode] = false
    },
    carrier() {
      this.serviceCode = this.carrier.services[0].code
    }
  },
  mounted() {
    this.setInitialData()
  },
  methods: {
    setInitialData() {
      this.schema = [
        { key: 'place_from', label: this.$t('Origen'), sortable: true },
        { key: 'place_to', label: this.$t('Destino'), sortable: true },
        { key: 'transit_days', label: this.$t('Días de tránsito base'), sortable: true },
        { key: 'transit_days_defaults', label: this.$t('Días de tránsito por defecto'), sortable: true },
        { key: 'increase', label: this.$t('Días adicionales temporales'), sortable: true },
        { key: 'vigency_range', label: this.$t('Rango de vigencia'), sortable: true }
        // {key: 'actions', label: 'Acciones', class: ['text-center']}
      ]

      this.actions = [
        // { name: 'eliminar', key: 'delete', icon: 'TrashIcon', color: 'danger', action: (id) => this.confirmRemoveCourierCompany(this.rows.find(data => data.id === id)?.master_id || null) }
      ]

      this.fields = [
        { fieldType: 'FieldSelect', name: 'from_place', label: this.$t('Origen'), containerClass: 'col-sm-12 col-md-5 container-info', clearable: true, searchOnType: { fx: this.setPlaces, nChars: 3, debounce: 600, persistSearch: true }},
        { fieldType: 'FieldSelect', name: 'to_place', label: this.$t('Destino'), containerClass: 'col-sm-12 col-md-5 container-info', clearable: true, searchOnType: { fx: this.setPlaces, nChars: 3, debounce: 600, persistSearch: true }}
      ]
      this.serviceCode = this.carrier.services[0].code
      this.empty = this.emptyFixedMsg
    },
    setServiceCode(code) {
      this.serviceCode = code
      if (this.m_isNotEmpty(this.formFilter)) this.getTransitDays()
    },
    filterData() {
      if (!this.m_isNotEmpty(this.formFilter)) {
        this.$bvToast.toast('Utilice los selectores de origen y/o destino antes de relizar la búsqueda.', {
          title: this.$t('Campos faltantes'),
          variant: 'warning',
          solid: true
        })
        return
      }
      this.getTransitDays()
    },
    getTransitDays() {
      this.loading.courierTransitDay = true
      this.loading[this.serviceCode] = true
      const queryParams = {
        carrier_code: this.carrier?.code,
        service_code: this.serviceCode,
        status: 2
      }
      if (this.formFilter.from_place) queryParams.from_place = this.formFilter.from_place.name
      if (this.formFilter.to_place) queryParams.to_place = this.formFilter.to_place.name

      this.$store.dispatch('fetchService', { name: 'getCourierTransitDays', queryParams })
    },
    async setPlaces(value) {
      const params = { country_id: this.carrier?.country.id }
      const queryParams = { str: value }
      return this.baseService.callService('getFullPlaces', queryParams, params)
        .then(resp => { 
          this.placesOptions = resp.places.map(el => ({...el, text: el.full_name, valid: true}))
          return this.placesOptions
        })
        .catch(err => { return err })
    },
    cleanFilter() {
      this.formFilter = {}
      this.rows = []
      this.empty = this.emptyFixedMsg
    }
  }

}
</script>

<style>
</style>
